<script lang="ts" setup>
import RenderHTML from '~/components/ui/RenderHTML.vue';

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});
defineEmits(['go-search']);
</script>
<template>
  <ul class="helpers">
    <li v-for="{ slug = '', id = '', data = '' } in items" :key="id">
      <nuxt-link :to="'/' + slug" @click="$emit('go-search')">
        <div class="text">
          <RenderHTML :seotext="data" />
        </div>
      </nuxt-link>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.helpers {
  margin-top: 12px;
  padding: 0;

  @media screen and (min-width: 1280px) {
    margin-top: 8px;
  }

  li {
    &:not(:last-child) {
      margin-bottom: 8px;
      @include md-block {
        margin-bottom: 12px;
      }
    }

    & + li {
      margin-top: 8px;
      padding-top: 8px;
      //border-top: 1px solid $achromatic-hover;
      @include md-block {
        padding-top: 12px;
        margin-top: 12px;
      }
      @include xl-block {
        border: none;
      }
    }

    a {
      display: flex;
      align-items: center;
      width: 100%;
      text-decoration: none;
      color: inherit;
    }

    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .end-hint {
        width: 100%;
        overflow: hidden;
      }
    }

    .img {
      width: 32px;
      height: 32px;
      min-height: 32px;
      margin-right: 8px;

      @include md-block {
        width: 40px;
        height: 40px;
        min-width: 40px;
        margin-right: 12px;
      }

      &.empty {
        background: $white2;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  & + .presets {
    margin-top: 8px;
    padding-top: 8px;
    @include md-block {
      padding-top: 12px;
      border-top: 1px solid $achromatic-hover;
      margin-top: 12px;
    }
    @include xl-block {
      border: none;
    }
  }
}

ul + ul {
  margin-top: 24px;
  @include md-block {
    margin-top: 40px;
  }
  @include xl-block {
    margin-top: 16px;
  }
}

.hint {
  font-weight: 600;
  color: $achromatic-black;
}
</style>
